import React from 'react';
import BoostedComponent from './BoostedComponent'
import ReservationInformations from './ReservationInformations'
import DateInput from './DateInput'
import moment from 'moment-with-locales-es6';

class ReservationMultiplesHoraire extends BoostedComponent {
  constructor(props) {
    super(props)
    let newState = Object.assign({},this.props.selected)
    if (newState && newState.plage) newState.plage = newState.plage.map(i=>{
      let newVal = Object.assign({},i)
      if (newVal.plateau[this.state.selected.plateau]!=1) newVal.checked = true
      return newVal
    })
    this.state = {
      selected: newState
    }

    this.parent = this.props.parent
    this.constants = this.props.constants
  }
  componentDidMount() {

  }
  jour = (n) => {
    n = +n;
    return this.constants.joursLabels[n]
  }
  componentDidUpdate(prevProps,prevState) {
    if (prevProps.selected !== this.props.selected) {



      let sele = this.props.selected.reduce((acc,current,index) => {
        if (!acc.debut || acc.debut > current.debut) acc.debut = current.debut;
        if (!acc.fin || acc.fin < current.fin) acc.fin = current.fin;
        acc.plage = acc.plage.concat(current.plage.map(i => {
          let j = Object.assign({},i);
          j.plateau = current.plateau
          j.occupe = i.plateau[current.plateau];
          return j
        }))
        return acc
      }, {plage: []})


      let newState = Object.assign({},sele)
      if (newState && newState.plage) newState.plage = newState.plage.map(i=>{
        let newVal = Object.assign({},i)
        if (newVal.occupe==0) newVal.checked = true
        return newVal
      })
      this.setState({
        selected: newState
      })
    }
    if (prevState.selected !== this.state.selected) {
      let aReserver =   [];
      if (this.state.selected && this.state.selected.plage) {
        aReserver =  this.state.selected.plage.filter(i=>i.checked).map(i=>{
          return {
            debut: i.debut/1000,
            fin: i.fin/1000,
            plateau: i.plateau
          }
        })
      }
      this.props.parent.setState({
        aReserver: aReserver
      })
    }
  }
  render() {

    moment.locale(this.props.constants.locale)
    return (
      <div>

        <div className="ReservationMultiplesTitre">
          <h3>{this.constants.semainesDisponibles}</h3>
          <p>{ this.constants.resmulti_horaire_instructions.replace("%",this.state.selected && this.state.selected.plage && this.state.selected.plage.filter(j => j.checked).length) }</p>
        </div>
        <table className="ReservationMultiplesSelection">
          <thead>
            <tr>
              <th>#</th>
              <th>{this.constants.date}</th>
              <th>{this.constants.heures}</th>
              <th><input
                checked={(this.state.selected && this.state.selected.plage && this.state.selected.plage.length == this.state.selected.plage.filter(i => (i.checked)).length)}
                onClick={(e) => {
                  this.state.selected.plage = this.state.selected.plage.map(i => Object.assign({},i,{checked: (e.target.checked) }))
                  this.setState({
                    selected: this.state.selected
                  })
                }}
                type="checkbox"
                /></th>
            </tr>
          </thead>
          <tbody>
            {this.state.selected && this.state.selected.plage && this.state.selected.plage.map((i,index)=>
              <tr key={index} className={ (i.occupe>0) ? "disabled" : (i.checked ? 'selectionne' : 'disponible'  ) }>
                <td>{index+1}</td>
                <td>{moment.utc(i.debut).format('dddd, ll')}</td>
                <td>{moment.utc(i.debut).format('HH:mm')}/{moment.utc(i.fin).format('HH:mm')}</td>
                <td>
                  <input
                    type="checkbox"
                    disabled={(i.occupe>0)}
                    checked={i.checked && i.occupe==0 }
                    onChange={(e)=>{
                      i.checked = (e.target.checked)
                      let newState = Object.assign({},this.state.selected)
                      this.setState({
                        selected: newState
                      })
                    }} 
                    />
                </td>
              </tr>
            )}
          </tbody>
        </table>

        <p>{this.constants.vousAvezSelectionne}  {this.state.selected && this.state.selected.plage && this.state.selected.plage.filter(j => j.checked).length} séance{(this.state.selected && this.state.selected.plage && this.state.selected.plage.length > 1) ? 's' : '' }</p>
      
        { this.state.selected && this.state.selected.plage && [0,1,2,3,4,5,6].map(i => {
          return this.state.selected.plage.filter(j => {
            if (i == moment.utc(j.debut).day() && j.checked) return true;
            return false
          }).length;
        }).map((i,index) =>
        { if (i > 0) return <div>{i} {this.jour(index)}</div> }
        )
      }
      <div className="ReservationMultiplesLegende">

        <div className="option1"><span>{this.constants.option1}</span></div>
        <div className="option2"><span>{this.constants.option2}</span></div>
        <div className="option3"><span>{this.constants.option3}</span></div>

      </div>
    </div>
  )
}
}

export default ReservationMultiplesHoraire;



// WEBPACK FOOTER //
// ./src/ReservationMultiples2.js